<button (click)="onClicked()" class="max-w-fit min-h-8 px-2.5 bg-primary shadow-lg rounded-full">
  @if(icon() == null) {
    <span class="line-clamp-2 text-xs text-white font-medium tracking-tightest">{{label()}}</span>
  }
  @else {
    <div class="flex flex-row">
      <span class="line-clamp-2 text-xs text-white font-medium tracking-tightest">{{label()}}</span>
      <img [src]="icon()" class="w-4 max-w-4 h-4 max-h-4 pl-1" style="filter: brightness(0) saturate(100%) invert(100%) sepia(100%) saturate(0%) hue-rotate(288deg) brightness(102%) contrast(102%);">
    </div>
  }
</button>
